import {Component, Input} from '@angular/core';
import {ProductQuery, SearchProductEntry} from '@services/resource/search-product-resources';
import {CommonModule} from '@angular/common';
import {ProductStateTranslate} from '@util/pipes/product-state-translate';

@Component({
  selector: 'app-ma-product-widget',
  templateUrl: './ma-product-widget.component.html',
  styleUrls: ['./ma-product-widget.component.scss'],
  standalone: true,
  imports: [CommonModule, ProductStateTranslate],
})
export class MaProductWidgetComponent {
  @Input() entry: SearchProductEntry;
  @Input() query?: ProductQuery;
}
